<script setup>
import { toRefs } from "vue";
import { usehistorialDeOfertasStore } from "@/store/historialDeOfertasStore";

const historialDeOfertasStore = usehistorialDeOfertasStore();
const { selected_tab, nombre_pestañas_menu } = toRefs(historialDeOfertasStore);

</script>

<template>
  <div>
    <ul
      class="nav nav-pills nav-justified rounded-2 mb-5 bg-soft-grey-ee border-0"
      role="tablist"
    >
      <li
        v-for="opcion in nombre_pestañas_menu"
        :key="opcion.id"
        class="nav-item"
        role="presentation"
        @click="historialDeOfertasStore.setSelectedTab(opcion)"
      >
        <button
          class="nav-link fw-600 fs-15"
          :class="[
            selected_tab.id === opcion.id
              ? 'active text-soft-green bg-white rounded-0'
              : 'text-black',
          ]"
        >
          {{ opcion.nombre_pestaña }}
        </button>
      </li>
    </ul>
  </div>
</template>
